import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';
import StatsCard from '../../components/common/StatsCard';
import EarningsSummary from '../../components/ib/EarningsSummary';
import CommissionBreakdown from '../../components/ib/CommissionBreakdown';
import ActiveReferrals from '../../components/ib/ActiveReferrals';
import { Users, DollarSign, Award, BarChart3 } from 'lucide-react';
import PageHeader from '../../components/common/PageHeader';
import TradeVolumeChart from '../../components/charts/TradeVolumeChart';

const IBDashboard = () => {
  const performanceData = [
    { date: '2024-01-01', volume: 150000, trades: 45 },
    { date: '2024-01-02', volume: 180000, trades: 52 },
    { date: '2024-01-03', volume: 120000, trades: 38 },
    { date: '2024-01-04', volume: 200000, trades: 61 },
    { date: '2024-01-05', volume: 170000, trades: 48 },
  ];

  return (
    <div className="space-y-6">
      <div className="sticky top-0 z-20 bg-background pt-4">
        <PageHeader title="IB Dashboard" />
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        <StatsCard title="Total Clients" value="0" icon={Users} change="+0%" />
        <StatsCard
          title="Total Commission"
          value="$0.00"
          icon={DollarSign}
          change="+0%"
        />
        <StatsCard
          title="Trading Volume"
          value="$0.00"
          icon={BarChart3}
          change="+0%"
        />
        <StatsCard title="Current Tier" value="Bronze" icon={Award} />
      </div>
      <ActiveReferrals />
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <EarningsSummary />
        <CommissionBreakdown />
      </div>
      <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
        <Card className="lg:col-span-2">
          <CardHeader>
            <CardTitle>Performance Overview</CardTitle>
          </CardHeader>
          <CardContent>
            <TradeVolumeChart data={performanceData} />
          </CardContent>
        </Card>
      </div>
    </div>
  );
};

export default IBDashboard;
